//
//
//
//

export default {
  name: "Error",
};
